import { render } from "./AppLoaderFill.vue?vue&type=template&id=50c05af0"
import script from "./AppLoaderFill.vue?vue&type=script&lang=js"
export * from "./AppLoaderFill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__